/**
 * Created by ChrisMuto on 6/28/17.
 */
import * as audienceActions from "./actions";
import { default as audienceReducers } from "./reducers";
import * as audienceTypes from "./types";
import * as audienceSelectors from "./selectors";

export { audienceActions, audienceTypes, audienceReducers, audienceSelectors };

export default audienceReducers;



// WEBPACK FOOTER //
// ./src/modules/audiences/index.js